import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import { default as _ContentLoader } from 'react-content-loader';
import cond from 'lodash/fp/cond';
import isNil from 'lodash/fp/isNil';
import useDarkMode from '../../hooks/useDarkMode';
const RECT = 'rect';
const CIRCLE = 'circle';
const DEFAULT_SPEED = 2;
const DEFAULT_HEIGHT = 14;
const DEFAULT_WIDTH = '100%';
const DEFAULT_RADIUS = 16;
const DEFAULT_TYPE = RECT;
const hasChildren = ({ children }) => !isNil(children);
const renderChildren = ({ children }) => children;
const isRect = ({ type }) => type === RECT;
const isCircle = ({ type }) => type === CIRCLE;
const renderRect = ({ rx = 3, ry = 3 }) => (_jsx("rect", { width: '100%', height: '100%', rx: rx, ry: ry }));
const renderCircle = ({ radius }) => _jsx("circle", { cx: radius, cy: radius, r: radius });
/**
 * This UIKIT component is simple wrapper to make it easier to use with a predefined look and feel. It still
 * allows for more complex configurations as all additional props are passed down to the third-party
 * ContentLoader component. For individual customization, it allows passing svg components as rect or circle
 * directly as children.
 * @param props
 * @returns
 */
const ContentLoader = (props) => {
    const { speed = DEFAULT_SPEED, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT, radius = DEFAULT_RADIUS, type = DEFAULT_TYPE, className = '', children } = props, remainingProps = __rest(props, ["speed", "width", "height", "radius", "type", "className", "children"]);
    const isDarkMode = useDarkMode();
    // Since we define the default values while destructuring the props, we have to build up a new object
    // with that defaults to be used in the conditional rendering, otherwise it would use only the props as
    // passed into the component without the defined defaults.
    const propsWithDefaults = {
        type,
        radius,
        children,
    };
    const content = cond([
        [hasChildren, renderChildren],
        [isRect, renderRect],
        [isCircle, renderCircle],
    ])(propsWithDefaults);
    const wrapperHeight = isCircle(propsWithDefaults) ? radius * 2 : height;
    const wrapperWidth = isCircle(propsWithDefaults) ? wrapperHeight : width;
    return (_jsx(_ContentLoader, Object.assign({ backgroundColor: '#f5f6f7', foregroundColor: isDarkMode ? '#aaaaaa' : '#eeeeee', speed: speed, height: wrapperHeight, width: wrapperWidth, className: `ContentLoader ${className} ${isDarkMode ? 'use-mix-blend-mode' : ''}` }, remainingProps, { children: content })));
};
ContentLoader.RECT = RECT;
ContentLoader.CIRCLE = CIRCLE;
export default ContentLoader;
